<template>
  <div
    :style="position"
    class="tooltip"
  >
    <div class="tooltip__top">
      <div class="tooltip__date">
        {{date}}
      </div>
      <div class="tooltip__time">
        {{time}}
      </div>
    </div>
    <div class="tooltip__bottom">
      <div class="tooltip__col1">
        <div class="tooltip__title">{{chartType}}</div>
        <div class="tooltip__val">{{marketcap}}</div>
      </div>
      <div class="tooltip__col2">
        <div class="tooltip__title">Volume 24h</div>
        <div class="tooltip__val">{{volume24h}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    position: Object,
    date: String,
    time: String,
    chartType: String,
    marketcap: String,
    volume24h: String,
  },
};
</script>

<style lang="scss" scoped>
  .tooltip {
    pointer-events: none;
    transition: $transition all;
    top: 0;
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 261px; // before change do CMD+F tooltipWidth
    box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    overflow: hidden;
    $padding-side: 19px;
    &__top {
      height: 74px;
      background: $red-color3;
      padding: 18px $padding-side 17px;
    }
    &__bottom {
      padding: 16px $padding-side 17px;
      display: flex;
      height: 69px;
      background-color: $white-color2;
    }
    &__col1,
    &__col2 {
      flex: 1;
    }
    &__date {
      @include font(14px, $white-color2, 600);
      line-height: 17px;
      margin-bottom: 5px;
    }
    &__time {
      @include font(12px, $grey-color13, 500);
      line-height: 15px;
    }
    &__title {
      @include font(12px, $grey-color9, 500);
      margin-bottom: 5px;
    }
    &__val {
      @include font(14px, $black-color1, 500);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/currency/chartBlock/Tooltip.vue